



























import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { NavigationLink } from "@/types/NavigationLink";

@Component
export default class NavigationBar extends Vue {
    @PropSync("drawer")
    _drawer: boolean;

    @Prop()
    links: Array<NavigationLink>;

    toggleDrawer(): void {
        this._drawer = !this._drawer;
    }

    toggleDark(): void {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        localStorage.setItem("darkMode", String(this.$vuetify.theme.dark));
    }

    mounted(): void {
        const saved = localStorage.getItem("darkMode");
        if (saved !== null) {
            this.$vuetify.theme.dark = saved === "true";
        } else {
            this.$vuetify.theme.dark = window.matchMedia("(prefers-color-scheme: dark)").matches;
        }
    }
}
